/** Сообщение об ошибке или успехе. Тон передаётся иконкой и текстом, не только цветом. */
import type { ReactNode } from 'react'
import { AlertCircle, CheckCircle2, Info } from 'lucide-react'
import { cn } from '@/shared/lib/cn'

type Tone = 'info' | 'success' | 'error'

const TONES: Record<Tone, { ring: string; text: string; Icon: typeof Info; label: string }> = {
  info: { ring: 'border-line', text: 'text-ink-soft', Icon: Info, label: 'Сообщение' },
  success: { ring: 'border-success/40', text: 'text-success', Icon: CheckCircle2, label: 'Готово' },
  error: { ring: 'border-danger/40', text: 'text-danger', Icon: AlertCircle, label: 'Ошибка' },
}

export function Callout({
  tone = 'info',
  children,
  className,
}: {
  tone?: Tone
  children: ReactNode
  className?: string
}) {
  const { ring, text, Icon, label } = TONES[tone]
  return (
    <div
      role={tone === 'error' ? 'alert' : 'status'}
      className={cn('flex items-start gap-2.5 rounded-md border bg-surface p-3', ring, className)}
    >
      <Icon aria-hidden className={cn('mt-0.5 size-4 shrink-0', text)} />
      <div className="text-meta text-ink-soft">
        <span className="sr-only">{label}: </span>
        {children}
      </div>
    </div>
  )
}
